const getAuthUrl = () => {
  const host = window.location.hostname;
  const authHost = host
    .split('.')
    .map((part, i) => {
      if (i === 0) {
        return 'auth';
      }

      return part;
    })
    .join('.');

  return `${window.location.protocol}//${host === 'localhost' ? 'auth.dev.lendingtree.com' : authHost}`;
};

const parseResponseAndCatchError = (resp) => {
  if (resp.ok) {
    return resp.json();
  }

  try {
    return resp.json();
  } catch (err) {
    logError('Request to auth service failed, failed parsing response body', {
      url: `${getAuthUrl()}/api/whoami`,
      err: {
        statusCode: resp.status,
        statusText: resp.statusText,
        message: err.message,
      },
    });

    showLoginButtons();
  }
};

const handleFailedRequest = (err) => {
  logError('Request to the auth service failed', {
    url: `${getAuthUrl()}/api/whoami`,
    err: {
      message: err.message,
    },
  });

  showLoginButtons();
};

const showLoginButtons = () => {
  const loginButtons = {
    desktop: document.getElementsByClassName('NavMenu--login-actions')[0],
    mobile: document.getElementsByClassName('SiteMobileHeader--login-button')[0],
  };

  loginButtons.desktop.classList.remove('NavMenu--is-hidden');
  loginButtons.mobile.classList.remove('SiteMobileHeader--is-hidden');
};

const shouldShowAuthMenu = (authData) => {
  const authDataKeys = Object.keys(authData);

  if (authDataKeys.length && authDataKeys.includes('firstName') && authDataKeys.includes('treeAuthUid')) {
    showAuthMenuItem(authData);
  } else {
    showLoginButtons();
  }
};

const showAuthMenuItem = (authData) => {
  const siteMobileHeader = document.getElementsByClassName('SiteMobileHeader--root')[0];
  const accountButton = document.getElementsByClassName('SiteMobileHeader--account-button')[0];
  const searchButton = document.getElementsByClassName('MainHeader--search-section')[0];
  const mobileAuthBlock = document.getElementsByClassName('AuthBlock--root')[0];
  const accountMenus = [...document.getElementsByClassName('NavMenu--my-lt-menu')];
  const userNameEls = [...document.getElementsByClassName('NavMenu--user-name')];

  siteMobileHeader.classList.toggle('SiteMobileHeader--is-logged-in');
  userNameEls.forEach((el) => (el.innerText = toCapitalized(`${authData.firstName} ${authData.lastName ?? ''}`)));
  accountMenus.forEach((el) => el.classList.remove('NavMenu--is-hidden'));
  accountButton.classList.remove('SiteMobileHeader--is-hidden');
  searchButton.classList.add('MainHeader--is-logged-in');
  mobileAuthBlock.classList.add('AuthBlock--is-hidden');
};

fetch(`${getAuthUrl()}/api/whoami`, {
  credentials: 'include',
})
  .then(parseResponseAndCatchError)
  .then(shouldShowAuthMenu)
  .catch(handleFailedRequest);
